import { render } from "./InfoForm.vue?vue&type=template&id=42f6bc66&scoped=true"
import script from "./InfoForm.vue?vue&type=script&lang=js"
export * from "./InfoForm.vue?vue&type=script&lang=js"

import "./InfoForm.vue?vue&type=style&index=0&id=42f6bc66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42f6bc66"

export default script